import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    "@keyframes save-icon-appear": {
        from: {
            opacity: 0,
        },
        to: {
            opacity: 1,
        },
    },
    container: {
        height: "100%",
        position: "relative",
        width: "100%",
    },
    conclusion_container: {
        position: "relative",
        borderBottom: "1px solid",
        [theme.breakpoints.down("sm")]: {
            paddingBottom: 30,
        },
    },
    conclusion_text_area: {
        border: "none",
        boxSizing: "border-box",
        fontFamily: "Roboto",
        fontSize: 14,
        paddingRight: 90,
        resize: "none",
        width: "100%",
        maxHeight: 125,
        color: "#000",
        [theme.breakpoints.down("sm")]: {
            paddingRight: 0,
        },
    },
    save_icon_container: {
        animationName: "$save-icon-appear",
        animationDuration: "200ms",
        animationTimingFunction: "linear",
        animationFillMode: "forward",
        color: "#5ee6b0",
        bottom: 5,
        position: "absolute",
        right: 10,
    },
    edit_icon_container: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        position: "absolute",
        right: 10,
        top: 10,
        [theme.breakpoints.down("sm")]: {
            top: "auto",
            right: "auto",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
        },
    },
    edit_icon: {
        [theme.breakpoints.down("sm")]: {
            fontSize: 12,
        },
    },
    length_counter: {
        position: "absolute",
        right: 18,
        top: 50,
        [theme.breakpoints.down("sm")]: {
            top: "auto",
            right: 0,
            bottom: 6,
        },
    },
    length_counter_text: {
        [theme.breakpoints.down("sm")]: {
            fontSize: 12,
        },
    },
    interpretation_container: {
        paddingTop: 10,
        [theme.breakpoints.down("sm")]: {
            paddingBottom: 10,
        },

        "& fieldset": {
            border: 0,
        },

        "& input": {
            fontSize: 14,
            fontFamily: "Roboto",
            paddingLeft: "2px !important",
            color: "#000",
        },

        '& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
            paddingLeft: "0px !important",
        }
    },
    interpretation_button_container: {
        // display: "flex",
        // justifyContent: "flex-end",
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        position: "absolute",
        right: 10,
        bottom: -10,
        [theme.breakpoints.down("sm")]: {
            top: "auto",
            right: "auto",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
        },
    },
}))
